// 引入 axios
import axios from "axios";
import {
  isMobile,
  getapp_mobile,
  afPostRecharge,
  getContainerClientType,
} from "./utils.js";
import Store from "@/lobby_common/store/index";
import { getLocalStorage, removeLocalStorage } from "./auth.js";
import eventKeys from "@/lobby_common/utils/eventKeys";
import { Encrypt } from "@/lobby_common/utils/secret.js";
import Adjust from "@adjustcom/adjust-web-sdk";
import { intAdjustSDK } from "@/lobby_common/utils/adjust.js";
import { toCocosAdjustFun } from "@/lobby_common/utils/appPostMessage.js";

// 新-数据打点
// type (
// 	EventLog struct {
// 		UserSid     int64  `json:"user_sid,optional"`     // 用户ID
// 		PlatformSid int64  `json:"platform_sid,optional"` // 平台ID
// 		AppSid      int64  `json:"app_sid,optional"`      // 应用ID
// 		PacketSid   int64  `json:"packet_sid,optional"`   // 包ID
// 		IP          string `json:"ip,optional"`           // IP地址(服务器)
// 		Country     string `json:"country,optional"`      // 国家(服务器)
// 		CountryCode string `json:"country_code,optional"` // 国家代码(服务器)
// 		City        string `json:"city,optional"`         // 城市(服务器)
// 		DeviceName  string `header:"device_name,optional"`// 设备名称
// 		DeviceId    string `header:"device_id,optional"`  // 设备识别码
// 		DeviceType  int64  `header:"device_type,optional"`// 设备类型
// 		EventTime   string `json:"event_time,optional"`   // 事件时间（服务器)）
// 		EventId     int64  `json:"event_id"`              // 事件id(必填，上报者 ： 客户端 或者 服务器)
// 		EventKey    string `json:"event_key"`             // 事件key(必填，上报者 ： 客户端 或者 服务器)
// 		EventValue  string `json:"event_value"`           // 事件值(必填，上报者 ： 客户端 或者 服务器)
// 		EventPre    int64  `json:"event_pre,optional"`    // 前一个事件id
// 		Channel     string `json:"channel,optional"`      // 渠道
// 		AdID        string `json:"ad_id,optional"`        // 广告id
// 		AdName      string `json:"ad_name,optional"`      // 广告名称
// 	}
// )
// eventKey事件key, opt 拓展参数  this.$eventPost('enter_web');
const mappingObj = {
  // 活动
  Jump_TYPE_ACTIVITY: {
    // activityType
    ActivityTypeRegister: 1,
    ActivityTypeFirstRecharge: 2,
    ActivityTypeRepeatRecharge: 3,
    ActivityTypeFirstRechargeGift: 4,
    ActivityTypeRepeatRechargeGift: 5,
    ActivityTypeRelief: 6,
    ActivityTypeBindAccount: 7,
    ActivityTypeRebate: 8,
    ActivityTypeSign: 9,
    ActivityTypeRank: 10,
    ActivityTypeTurntable: 11,
    ActivityTypeDepositRebate: 12,
    ActivityTypePrecious: 13,
    ActivityTypeGrandPrecious: 14,
    ActivityTypeRedeemCode: 15,
    ActivityTypeTimingRedEnvelope: 16,
    ActivityTypeNewUserHelp: 17,
    ActivityTypeInterestTreasure: 18,
    ActivityTypeCollectionCard: 19,
    ActivityTypeMysteriousRewards: 20,
    ActivityTypeWeekMonthCard: 21,
    ActivityTypeTeamRank: 22,
    ActivityTypeMultiRushBank: 23,
    ActivityTypeLimitedtimeDiscount: 24,
    ActivityTypeVipTurntable: 25,
    ActivityTypeRechargeTurntable: 26,
    ActivityTypeOffline: 1000,
    ActivityTypePromote: 1001,
    ActivityTypeDownload: 1002,
  },
  // 功能
  Jump_TYPE_FUNCTION: {
    // functionType
    JUMP_FUNCTION_TYPE_WEEK_MONTH_CARD: 106001, // [ 106001, 106002, 106003 ]
    JUMP_FUNCTION_TYPE_DOWNLOAD_PAGE: 106009,
  },
  // 任务
  JUMP_TYPE_TASK_CENTER: {
    jump_value: {
      type: "JUMP_TYPE_TASK_CENTER",
      activityType: 0,
    },
  },

  // other 映射服务器id // 以下是活动
  spin_recharge_enter: {
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeRechargeTurntable",
    },
  },
  rebate_activity_enter: {
    // 返利活动
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeRebate",
    },
  },
  eject_sign_home: {
    // 签到活动
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeSign",
    },
  },
  dama_rank_popup: {
    // 打码排行榜
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeRank",
    },
  },
  wheel_activity_enter: {
    // 转盘活动
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeTurntable",
    },
  },
  10340001: {
    // 宝箱活动
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypePrecious",
    },
  },
  10340001: {
    // 累计宝箱
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeGrandPrecious",
    },
  },
  rain_envelopes: {
    // 定时红包
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeTimingRedEnvelope",
    },
  },
  invite_get_more: {
    // 拉新助力
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeNewUserHelp",
    },
  },
  eject_interest_home: {
    // 利息宝
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeInterestTreasure",
    },
  },
  jiaka_home_popup: {
    // 集卡活动
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeCollectionCard",
    },
  },
  mystery_home_popup: {
    // 神秘奖励
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeMysteriousRewards",
    },
  },
  card_web_pop: {
    // 周月卡
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeWeekMonthCard",
    },
  },
  10240004: {
    // 团队打码排行榜
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeTeamRank",
    },
  },
  rank_home_popup: {
    // 开服冲榜
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeMultiRushBank",
    },
  },
  click_charge: {
    // 限时优惠
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeLimitedtimeDiscount",
    },
  },
  collect_word_wheel_enter: {
    // VIP集字转盘
    jump_value: {
      type: "Jump_TYPE_ACTIVITY",
      activityType: "ActivityTypeVipTurntable",
    },
  },
  // 任务
  task_center_show: {
    jump_value: {
      type: "JUMP_TYPE_TASK_CENTER",
    },
  },
  recharge_gift_popup: {
    jump_value: {
      type: "Jump_TYPE_FUNCTION",
      functionType: "JUMP_FUNCTION_TYPE_DOWNLOAD_PAGE",
    },
  },
};

const errorMap = {};
export const eventPost = async (eventKey, opt = {}) => {
  const app_mobile = getapp_mobile();
  try {
    // 上报接口报错
    if (window.eventErrorNum >= 3) {
      return;
    }
    if (eventKey === "err_log" || eventKey === "timeout_log_web") {
      opt.pathname = window.location.pathname;
      // 相同错误只上报一次
      if (errorMap[opt.msg]) {
        return;
      }
      errorMap[opt.msg] = true;
    }
    const invite_code = getLocalStorage("inviteCode") || "";
    const optdata = opt || {}; // 事件值
    const containerClientType = getContainerClientType();

    if (mappingObj[eventKey]) {
      optdata.jump_value = mappingObj[eventKey].jump_value;
    }

    // 处理optdata 映射
    // 第一种格式
    const jump_value = optdata.jump_value || {};
    if (jump_value.type) {
      const obj = mappingObj[jump_value.type] || {};
      // 活动
      if (jump_value.type === "Jump_TYPE_ACTIVITY") {
        optdata.jump_value.functionType_sid = obj[jump_value.activityType];
      }
      // 功能
      if (jump_value.type === "Jump_TYPE_FUNCTION") {
        optdata.jump_value.functionType_sid = obj[jump_value.functionType];
      }
      // 任务
      if (jump_value.type === "JUMP_TYPE_TASK_CENTER") {
        optdata.jump_value.functionType_sid = 0;
      }
    }
    // 第二种格式
    const exposureList = optdata.exposureList || [];
    if (exposureList && exposureList.length > 0) {
      exposureList.map((v) => {
        const arr = v || [];
        arr.map((i) => {
          const objItem = { ...i };
          const jump_value = i.jump_value || {};
          if (jump_value.type) {
            const obj = mappingObj[jump_value.type] || {};
            // 活动
            if (jump_value.type === "Jump_TYPE_ACTIVITY") {
              objItem.jump_value.functionType_sid =
                obj[jump_value.activityType];
            }
            // 功能
            if (jump_value.type === "Jump_TYPE_FUNCTION") {
              objItem.jump_value.functionType_sid =
                obj[jump_value.functionType];
            }
            // 任务
            if (jump_value.type === "JUMP_TYPE_TASK_CENTER") {
              objItem.jump_value.functionType_sid = 0;
            }
          }
          return objItem;
        });
        return arr;
      });
    }

    const event_value = JSON.stringify({
      invite_code: invite_code,
      ...optdata,
      web_url: window.location.hostname,
      terminal_type: containerClientType.containerType,
      unique_id: window.localStorage.getItem("uniqueId") || "", // fb url 三方id
      connection: checkNetworkStatus(),
    }); // 拓展参数
    // console.log(event_value ,'event_value')
    // console.log(`触发打点事件：key ${eventKey}`, opt);
    if (!eventKeys[eventKey]) return;
    const localUserData =
      getLocalStorage("USER_DATA") || getLocalStorage("USER_LOGIN_DATA") || {};
    const userData = Store.getters.user || {};
    const userInfo = userData.sid ? userData : localUserData;
    // console.log("=======userInfo=========", userData, localUserData);
    const channel_id = localStorage.getItem("channelId") || "0";
    let media_id = "";
    let material_id = "";
    if (getLocalStorage("kwai_obj")) {
      const kwai_obj = getLocalStorage("kwai_obj") || {};
      media_id = kwai_obj?.pixel_id || ""; // 媒体id
      material_id = kwai_obj?.click_id || ""; // 素材id
    } else if (getLocalStorage("fbclid")) {
      media_id = getLocalStorage("fb_pixel_id") || ""; // 媒体id
      material_id = getLocalStorage("fbclid") || ""; // 素材id
    }
    const params = {
      event_id: Number(eventKeys[eventKey]), // 事件id 事件key
      event_key: eventKey,
      event_value: event_value || "", // 事件值
      user_sid: userInfo.sid || opt?.userSid, // 用户ID
      user_create_type: userInfo.userCreateType || opt?.userCreateType, // 用户类型
      platform_sid: Store.getters.getPacketDomain?.platformSid, // 平台ID
      app_sid: Store.getters.getPacketDomain?.appSid, // 应用ID
      packet_sid: Store.getters.getPacketDomain?.packSid, // 包ID
      device_name: "", // 设备名称 浏览器版本
      device_id: "", // 设备识别码 浏览器指纹
      device_type: isMobile() ? 2 : 1, // 设备类型 USER_CLIENT_TYPE_H5:USER_CLIENT_TYPE_PC
      channel_id, // 渠道id
      ad_id: "", // 广告id  三方
      ad_name: "", // 广告名称 三方
      event_pre: 0, // 前一个事件id
      //  terminal_type: localStorage.getItem("terminaltype") || 'normal',
      user_coin_code: userInfo.coinCode || opt?.coinCode, // 用户货币
      agent_account: userInfo.agentAccount || opt?.agentAccount || "", // 用户所属专业代理账号
      time_zone: Store.getters?.getPacketConfig?.appConfig?.timeZone, // 时区
      language: Store.getters.getLang,
      app_mobile: app_mobile?.os + "/" + app_mobile?.model || "",
      media_id, // 媒体id
      material_id, // 素材id
      container_type: containerClientType.containerType,
      client_type: containerClientType.clientType, // 与device_type取的设备方式不一致
    };

    // 浏览器指纹
    let browser = localStorage.getItem("browser");
    browser = browser ? JSON.parse(browser) : "";
    if (browser?.browser && browser?.murmur) {
      params.device_id = browser.murmur;
      params.device_name = browser.browser;
    }

    const initQuery = getLocalStorage("initQuery") || {};
    const isFromApp = Boolean(window.localStorage.getItem("isFromApp"));
    // 马甲包
    if (isFromApp) {
      params.device_id = initQuery?.device_id || params.deviceId;
      params.device_name = initQuery?.ft || params.deviceName;
      // if (initQuery.ft?.toLowerCase() === "android") {
      //   params.device_type = 5; // USER_CLIENT_TYPE_ANDROID_H5
      // }
      // if (initQuery.ft?.toLowerCase() === "ios") {
      //   params.device_type = 6; // USER_CLIENT_TYPE_IOS_H5
      // }
    }

    // console.log("打点参数", params);
    if (!Store.getters.getPacketDomain?.clientReportLogUrl) return;
    // 发送 POST 请求
    let data = {};
    const queryObj = getLocalStorage("localInitQuery") || {};
    const localSkmode = getLocalStorage("skmode");
    const skmode = queryObj.skmode || localSkmode;
    let config = {};
    if (skmode === "true" || skmode === true) {
      data = { ...params };
      config = {
        headers: {
          "X-STREAKING-MODE": "DEBUG",
          "X-Header-Client-Type": containerClientType.clientType,
          "X-Header-Container-Type": containerClientType.containerType,
        },
      };
    } else {
      data = { data: Encrypt(params) };
      config = {
        headers: {
          "X-Header-Client-Type": containerClientType.clientType,
          "X-Header-Container-Type": containerClientType.containerType,
        },
      };
    }

    axios
      .post(
        Store.getters.getPacketDomain?.clientReportLogUrl + "/event",
        data,
        config
      )
      .then((response) => {
        // 处理响应数据
        // console.log('Response data:', response);
      })
      .catch((error) => {
        // 处理错误
        // console.error('Error:', error);
      });
  } catch (error) {
    console.log(error);
  }
};

// af
let afEvents = {};
const afPostHref = "mailto://appsFlyerLibEvent.com?value=";
const afOpenHref = "mailto://openWindow.com?value=";
export const initAF = (config, adsEventConfig) => {
  // console.log("==========initAF============", config);
  afEvents = { ...config };
  const androidview = localStorage.getItem("AFAndroidview");
  // console.log("==========androidview============", androidview);
  // 携带了androidview参数，并且配置了af上报
  if (androidview) {
    // af浏览页面
    afPostEvent({ event: "contentView" });
    // 如果之前有存储的订单，查看状态
    afPostRecharge(adsEventConfig);
  }
};
// af上报事件
export const afPostEvent = (opt = {}) => {
  console.log("=======afPostEvent=======", afEvents, opt);
  const androidview = localStorage.getItem("AFAndroidview");
  // 携带了androidview参数，并且配置了af上报
  if (androidview) {
    // const params = {};
    // if (afEvents[opt.event]) {
    locationJump(JSON.stringify(opt), 1);
    // }
  }
};
// location.href跳转
export const locationJump = (url, type) => {
  // type: 1 af上报,  2 window.open类型过来的,  3 location.href过来的需要拼域名,  不传 location.href过来的,
  const androidview = localStorage.getItem("AFAndroidview");
  // 携带了androidview参数，并且配置了af上报
  if (androidview) {
    if (type === 1) {
      location.href = afPostHref + url;
      console.log("=======11111111=======", afPostHref + url);
    } else if (type === 3) {
      // 获取当前域名
      const domain = getCurDomain();
      location.href = afOpenHref + domain + url;
      // console.log("=======22222222=======", afOpenHref + domain + url);
    } else {
      location.href = afOpenHref + url;
      // console.log("=======33333333=======", afOpenHref + url);
    }
  } else {
    if (type === 2) {
      // console.log("=======44444444=======", url);
      window.open(url, "_self");
    } else {
      // console.log("=======555555555=======", url);
      location.href = url;
    }
  }
};
// 快手
export const kwaiqPost = (key, opt = {}) => {
  if (!window.kwai_pixel || !key) return;
  if (kwaiq) {
    kwaiq?.instance(window.kwai_pixel).track(key, opt);
  }
};

// 谷歌
export const intGoogleSDK = (config) => {
  // console.log(config, "config------------11111111111");
  if (config?.measurement_id) {
    // <!-- Google tag (gtag.js) -->
    // <script async src="https://www.googletagmanager.com/gtag/js?id=G-0F6X2DHSXK"></script>
    // <script> window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-0F6X2DHSXK'); </script>
    const src =
      "https://www.googletagmanager.com/gtag/js?id=" + config.measurement_id;
    const newScript = document.createElement("script");
    newScript.src = src;

    // 设置script的async属性为false，以确保脚本同步加载
    newScript.async = false;

    // 可选：设置其他属性，如type
    newScript.type = "text/javascript";

    // 将script元素添加到文档的head或body中
    document.head.appendChild(newScript); // 或者 document.body.appendChild(script);

    // 可选：在脚本加载完成后执行回调
    newScript.onload = function () {
      console.log("脚本加载完成");
      const contentScript = document.createElement("script");
      // 设置script的内容
      contentScript.textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${config.measurement_id}');
    `;
      // console.log(12123, dataLayer);
      // 将script元素添加到文档的head或body中
      document.head.appendChild(contentScript);
      if (!localStorage.getItem("googlePushdevice")) {
        setTimeout(() => {
          // console.log("==========gtag=========", gtag);
          const params = {};
          const initQuery = getLocalStorage("initQuery") || {};
          const isFromApp = Boolean(window.localStorage.getItem("isFromApp"));
          // 浏览器指纹
          let browser = localStorage.getItem("browser");
          browser = browser ? JSON.parse(browser) : "";
          if (browser?.browser && browser?.murmur) {
            params.device_id = browser.murmur;
            params.device_name = browser.browser;
          }
          // 马甲包
          if (isFromApp) {
            params.device_id = initQuery?.device_id || params.deviceId;
            params.device_name = initQuery?.ft || params.deviceName;
            if (initQuery.ft?.toLowerCase() === "android") {
              params.device_type = 5; // USER_CLIENT_TYPE_ANDROID_H5
            }
            if (initQuery.ft?.toLowerCase() === "ios") {
              params.device_type = 6; // USER_CLIENT_TYPE_IOS_H5
            }
          }
          // console.log("==========params=========", params);
          gtag("event", "getdevice", {
            ...params,
            // debug_mode: true, // 本地调试模式
          });
          localStorage.setItem("googlePushdevice", true);
        }, 50);
      }
    };

    // 可选：处理脚本加载失败的情况
    newScript.onerror = function () {
      console.error("脚本加载失败");
    };
  }
};

const gtagEvents = [];
export const gtagGoogle = (event, params = {}) => {
  // const adsEventConfig = Store.state.adsEventConfig || [];
  // const channelCodeObj = {};
  // adsEventConfig.map((v) => {
  //   channelCodeObj[v.channelCode] = { ...v };
  // });
  // // if (channelCodeObj["ADS_CODE_GOOGLEPUSH"]) {
  // const configJson = channelCodeObj["ADS_CODE_GOOGLEPUSH"]?.config || "";
  // const cofuncConfigJosn = channelCodeObj["ADS_CODE_GOOGLEPUSH"]?.funcConfig || "";
  // const config = configJson ? JSON.parse(configJson) : {};
  // const funcConfig = cofuncConfigJosn ? JSON.parse(cofuncConfigJosn) : {}
  // gtagEvents.push({ event: event, params: { ...params }})
  // if (channelCodeObj["ADS_CODE_GOOGLEPUSH"] && config.id) {
  //   gtagEvents.map(v => {
  //     if(funcConfig[v.event]) {
  //       gtag('event', funcConfig[v.event], {
  //         ...v.params,
  //         debug_mode: true,  // 本地调试模式
  //       })
  //     }
  //   })
  //   gtagEvents = []
  // }
};

//
let adjustEvents = [];

// Adjust
export async function adjustTrackEvent(params) {
  console.log("adjustTrackEvent", params);
  const adsEventConfig = Store.state.adsEventConfig || [];
  const channelCodeObj = {};
  adsEventConfig.map((v) => {
    channelCodeObj[v.channelCode] = { ...v };
  });

  // if (channelCodeObj["ADS_CODE_ADJUST"]) {
  const configJson = channelCodeObj["ADS_CODE_ADJUST"]?.config || "";
  const cofuncConfigJosn = channelCodeObj["ADS_CODE_ADJUST"]?.funcConfig || "";
  const config = configJson ? JSON.parse(configJson) : {};
  const funcConfig = cofuncConfigJosn ? JSON.parse(cofuncConfigJosn) : {};
  if (channelCodeObj["ADS_CODE_ADJUST"] && config.appToken) {
    console.log(params, "params ");
    await Adjust.trackEvent({
      ...params,
      eventToken: funcConfig[params.eventToken],
    });

    // 触发存起来的事件
    if (adjustEvents.length) {
      adjustEvents.map((item) => {
        Adjust.trackEvent({ ...item, eventToken: funcConfig[item.eventToken] });
        toCocosAdjustFun(funcConfig[params.eventToken]);
      });
      adjustEvents = [];
    }
  }
  // console.log("========eventToken=======", funcConfig[params.eventToken]);
  // 调用 cocos adjust 通信
  toCocosAdjustFun(funcConfig[params.eventToken]);

  // console.log('adjustTrackEvent', params, config.appToken, adjustEvents)
  // tg过来，登陆太快Adjust sdk可能来没回来，先存起来。下次触发
  if (!config.appToken) {
    adjustEvents.push(params);
  }
}
export function getCurDomain() {
  const protocol = window.location.protocol; // http: 或 https:
  const domain = window.location.hostname; // 域名
  const port = window.location.port; // 端口（如果有的话）
  const fullDomain = `${protocol}//${domain}${port ? ":" + port : ""}`;
  console.log("fullDomain", fullDomain);
  return fullDomain;
}

function checkNetworkStatus() {
  if (!navigator.onLine) {
    return { status: "offline", type: "unknown" };
  }
  if ("connection" in navigator) {
    const conn = navigator.connection;
    return {
      status: "online",
      type: conn.type || "unknown",
      effectiveType: conn.effectiveType || "unknown",
      downlink: conn.downlink || "unknown",
    };
  }
  return { status: "online", type: "unknown" };
}
